// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Switch,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";

import { useMaterialUIController } from "context";
import usePageTitle from "app/pageTitle";

function PostP2POrder() {
  const pageTitle = "New Order";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  // const [exchangeRates, setExchangeRates] = useState([]);
  const [rawRates, setRawRates] = useState([]);
  const [calculated, setCalculated] = useState(false);
  const [commercialLine, setCommercialLine] = useState("");
  const [rateLine, setRateLine] = useState("");

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  // const rateColumns = [
  //   {
  //     Header: <MDTypography variant="h6">Pair</MDTypography>,
  //     accessor: "pair",
  //     width: "30%",
  //     align: "left",
  //   },
  //   { Header: <MDTypography variant="h6">Buy At</MDTypography>, accessor: "buy", align: "center" },
  //   { Header: <MDTypography variant="h6">Sell At</MDTypography>, accessor: "sell", align: "right" },
  // ];

  // const buildRateRows = (data) => {
  //   const rateRows = [];
  //   data.map((item) => {
  //     rateRows.push({
  //       pair: item.pair,
  //       buy: item.buy / 100,
  //       sell: item.sell / 100,
  //     });
  //     return null;
  //   });
  //   return rateRows;
  // };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("p2p/market/rates.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setRawRates(result.data.data.rates);
            // const ratesC = buildRateRows(result.data.data.rates);
            // setExchangeRates(ratesC);
            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("p2p-create")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Make sure you have an active internet connection.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [pairs, setPairs] = useState([]);
  const [baseCurrency, setBaseCurrency] = useState(null);
  const [quoteCurrency, setQuoteCurrency] = useState("NGN");
  const [state, setState] = useState({});
  const {
    currencyPair = null,
    amount = null,
    minAmount = null,
    orderType = "LIMIT",
    limitRate = null,
    orderSide = null,
    allowPartials = true,
  } = state;

  const handleSwitchChange = (event) => {
    setState({ ...state, allowPartials: event.target.checked });
  };

  function showCommercials() {
    if (baseCurrency === null || quoteCurrency === null) {
      return;
    }

    if (orderSide === null) {
      return;
    }

    if (amount === null) {
      return;
    }

    let buyRate = 0;
    let sellRate = 0;
    if (orderType === "LIMIT") {
      if (limitRate === null || limitRate <= 0) {
        return;
      }

      buyRate = limitRate;
      sellRate = limitRate;
    } else {
      rawRates.forEach((ra) => {
        if (ra.pair === `${baseCurrency}${quoteCurrency}`) {
          buyRate = ra.buy / 100;
          sellRate = ra.sell / 100;
        }
      });
    }

    const rLine = `Ex. Rate: 1 ${baseCurrency} = ${
      orderSide === "BUY" ? buyRate : sellRate
    } ${quoteCurrency}`;
    setRateLine(rLine);

    let cLine = "";
    const dir = orderSide === "BUY" ? "pay" : "receive";
    if (orderType === "LIMIT") {
      const fee = amount * 0.01;
      const amt = orderSide === "BUY" ? parseInt(amount, 10) + fee : amount - fee;
      const fAmt = amt * limitRate;
      cLine = `You ${dir} ${quoteCurrency} ${fAmt}`;
    } else {
      const rattte = orderSide === "BUY" ? buyRate : sellRate;
      cLine = `You ${dir} approximately ${quoteCurrency} ${amount * rattte}`;
    }

    setCommercialLine(cLine);
    setCalculated(true);
  }

  const handleInputChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
    setCalculated(false);
  };

  function handleCurrencyChange(pair) {
    setBaseCurrency(pair.substring(0, 3));
    setQuoteCurrency(pair.slice(-3));
    setState({ ...state, currencyPair: pair });
    setCalculated(false);
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("p2p/market/currencies/pairs.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPairs(result.data.data.currency_pairs);
            setBaseCurrency("USD");
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Make sure you have an active internet connection.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const postData = async (params) => {
    setShowLoading(true);
    const json = JSON.stringify(params);
    await axios
      .post("p2p/orders/create.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          // setSeverity("success");
          // setErrMsg(response.data.data.message);
          // setOpen(true);
          navigate(`/p2p/fx/my-orders/${response.data.data.order.reference}`);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg("An error occurred. Make sure you have an active internet connection.");
        setOpen(true);
        setShowLoading(false);
      });
  };

  const handleSubmit = () => {
    if (currencyPair === null) {
      setSeverity("error");
      setErrMsg("Please select a currency pair");
      setOpen(true);
      return;
    }

    if (orderSide === null) {
      setSeverity("error");
      setErrMsg("Select a side. Are you buying or selling?");
      setOpen(true);
      return;
    }

    if (amount === null || amount <= 0) {
      setSeverity("error");
      setErrMsg("Please enter a valid amount.");
      setOpen(true);
      return;
    }

    if (orderType === null) {
      setSeverity("error");
      setErrMsg("Please select an order type.");
      setOpen(true);
      return;
    }

    if (orderType === "LIMIT") {
      if (limitRate === null || limitRate <= 0) {
        setSeverity("error");
        setErrMsg("Please set a valid exchange rate");
        setOpen(true);
        return;
      }
    }

    if (!calculated) {
      showCommercials();
      return;
    }

    const params = {
      currency_pair: currencyPair,
      side: orderSide,
      amount: amount * 100,
      min_transaction_amount: minAmount * 100,
      order_type: orderType,
      allow_partial_fill: allowPartials,
      limit_rate: limitRate * 100,
    };

    // console.log(params);
    postData(params);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null ? (
        <Dialog open={showCompanyNotification}>
          <DialogTitle>
            <MDBox>{companyNotification.title}</MDBox>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <MDBox>{companyNotification.description}</MDBox>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setShowCompanyNotification(false);
              }}
              color="dark"
              variant="outlined"
            >
              Close
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox sx={{ marginBottom: "40px" }}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between">
                    <MDBox>
                      <MDButton
                        variant="link"
                        color="dark"
                        onClick={() => {
                          navigate("/p2p/fx");
                        }}
                      >
                        P2P Orders
                      </MDButton>
                    </MDBox>
                    <MDBox>
                      <MDButton
                        variant="link"
                        color={darkMode ? "white" : "dark"}
                        onClick={() => {
                          navigate("/p2p/fx/my-orders");
                        }}
                      >
                        My Orders
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Post Order
                      </MDTypography>
                      <MDBox mt={5}>
                        <MDBox mb={3}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Currency Pair</InputLabel>
                                <Select
                                  label="Currency Pair"
                                  defaultValue="USDNGN"
                                  onChange={(e) => handleCurrencyChange(e.target.value)}
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  value={currencyPair || ""}
                                >
                                  {
                                    // --> Notice below changes
                                    pairs.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                      pairs.map((record) => (
                                        <MenuItem value={record.code}>{record.code}</MenuItem>
                                      ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                <InputLabel>Buy/Sell</InputLabel>
                                <Select
                                  label="Buy/Sell"
                                  defaultValue="SELL"
                                  name="orderSide"
                                  sx={{ padding: "10px", paddingLeft: "3px" }}
                                  onChange={handleInputChange}
                                  value={orderSide || ""}
                                >
                                  <MenuItem value="BUY">BUY</MenuItem>
                                  <MenuItem value="SELL">SELL</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={1}>
                          <MDInput
                            value={amount || ""}
                            onChange={handleInputChange}
                            name="amount"
                            label={`${baseCurrency} Amount`}
                            sx={{ minWidth: 120, width: "100%" }}
                          />
                        </MDBox>
                        {/* <MDBox mt={5}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Order Type</InputLabel>
                            <Select
                              label="Order Type"
                              defaultValue="market"
                              name="orderType"
                              sx={{ padding: "10px", paddingLeft: "3px" }}
                              value={orderType || ""}
                              onChange={handleInputChange}
                            >
                              <MenuItem value="MARKET">Market Order</MenuItem>
                              <MenuItem value="LIMIT">Fixed Order</MenuItem>
                            </Select>
                          </FormControl>
                        </MDBox> */}
                        {orderType === "LIMIT" ? (
                          <MDBox mt={3} mb={3}>
                            <MDInput
                              mb={3}
                              name="limitRate"
                              label={`Exchange Rate (${quoteCurrency})`}
                              sx={{ minWidth: 120, width: "100%" }}
                              value={limitRate || ""}
                              onChange={handleInputChange}
                            />
                            <MDBox mt={1}>
                              <Alert severity="info" sx={{ width: "100%" }}>
                                {/* <small>Enter your preferred exchange rate.</small>
                                <br /> */}
                                <small>1% transaction fee applies</small>
                              </Alert>
                            </MDBox>
                          </MDBox>
                        ) : (
                          <br />
                        )}
                        <MDBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mt={1}
                          lineHeight={1}
                        >
                          <MDTypography variant="h6">
                            <small>Allow partial fill?</small>
                          </MDTypography>

                          <Switch
                            defaultChecked
                            checked={allowPartials}
                            onChange={handleSwitchChange}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </MDBox>
                        <MDBox mt={2}>
                          <MDInput
                            disabled={!allowPartials}
                            name="minAmount"
                            label={`${baseCurrency} Minimum Amount`}
                            sx={{ minWidth: 120, width: "100%" }}
                            value={minAmount || ""}
                            onChange={handleInputChange}
                          />
                        </MDBox>
                        {calculated ? (
                          <MDBox mt={5}>
                            <Alert severity="warning" sx={{ width: "100%" }}>
                              <MDTypography variant="h6">{commercialLine}</MDTypography>
                              <MDTypography variant="h6">{rateLine}</MDTypography>
                            </Alert>
                          </MDBox>
                        ) : (
                          <> </>
                        )}
                        <MDBox mt={5}>
                          <MDButton variant="contained" color="dark" onClick={handleSubmit}>
                            Post Order
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                {/* <MDBox sx={{ marginBottom: "45px" }}>
                  <Card>
                    <MDBox pt={3}>
                      <DataTable
                        table={{ columns: rateColumns, rows: exchangeRates }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    </MDBox>
                  </Card>
                </MDBox> */}
                <MDBox sx={{ marginBottom: "35px" }}>
                  <Card>
                    <MDBox p={0}>
                      <Alert severity="info" sx={{ width: "100%" }}>
                        <AlertTitle>Order Tips</AlertTitle>
                        {/* <p>
                          <b>Market orders</b> are the recommended option. You buy/sell at the
                          current market rate shown. Take advantage of price fluctuation in the
                          market.
                        </p>
                        <br /> */}
                        <p>
                          <b>Set</b> your own rate. Note that your order will be accepted by peers
                          who are willing to swap at your rate.
                        </p>
                        <br />
                        <p>
                          <b>Partial Fill</b> let&apos;s your order get filled by many peers.
                          Disabling this will limit your order to only a peer&apos;s order that
                          exactly matches your order amount.
                        </p>
                        <br />
                        <p>
                          <b>Minimum amount</b> applies only for orders with partial fill enabled.
                          Set the minimum amount you are willing to exchange with peers.
                        </p>
                      </Alert>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PostP2POrder;
